import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import image1 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي ثوم.jpg";
import image2 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي جزر.jpg";
import image3 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي خيار.jpg";
import image4 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي فلفل أحمر.jpg";
import image5 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي فلفل هاليبينو.jpg";
import image6 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي لوز.jpg";
import image7 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر محشي ليمون.jpg";

import contact from "../Images/Group-of-customer-service-representatives.jpg";

export default function ProductStuffedAr() {
  const [loading, setLoading] = useState(false);
  const [productName, setProductName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  async function sendQuote(e) {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `https://mrolive-back-end-2c3o.onrender.com/api/v1/quote`,
        {
          name: name,
          email: email,
          productName: productName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.msg);
        setName("");
        setEmail("");
        document.getElementById("name").value = "";
        document.getElementById("email").value = "";
      })
      .catch((e) => {
        toast.error(e?.data?.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  let imgList = Array.from(document.getElementsByClassName("imgItem"));
  let lightContainer = document.querySelector(".lightContainer");
  let lightBox = document.querySelector(".lightBox");
  let currentIndex = 0;
  console.log(lightContainer);

  function showImage(x) {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-none", "d-flex");
    // console.log("ayhagaaasa")
    document.querySelector(".very").style.backgroundImage = `url(${x.src})`;
    document.querySelector(".productName").innerHTML = x.name;
    currentIndex = x.id;
    // console.log(currentIndex)
  }

  function closeSlide() {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-flex", "d-none");
  }
  function showForm() {
    document
      .querySelector(".showForm")
      .classList.replace("d-none", "d-inline-block");
  }

  return (
    <>
      <div className="products " onClick={closeSlide}></div>
      <div className="container p-4">
        <div className="row p-3">
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="1"
                src={image1}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي ثوم");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي ثوم"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي ثوم
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="2"
                src={image2}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي جزر");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي جزر"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي جزر
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="3"
                src={image3}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي خيار");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي خيار"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي خيار
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="4"
                src={image4}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي فلفل أحمر");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي فلفل أحمر"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي فلفل أحمر
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="5"
                src={image5}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي فلفل هاليبينو");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي فلفل هاليبينو"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي فلفل هاليبينو
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="6"
                src={image6}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي لوز");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي لوز"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي لوز
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="7"
                src={image7}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("زيتون أخضر محشي ليمون");
                }}
                alt="image not found"
                className="photo"
                name="زيتون أخضر محشي ليمون"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              زيتون أخضر محشي ليمون
            </p>
          </div>
        </div>
      </div>
      <div className="lightContainer2 d-none  align-items-center">
        <div className="lightBox2  ">
          <div className="container">
            <div className="row d-flex justify-content-center ">
              <div className="ayhaga" style={{ marginTop: "30px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img className=" very" alt="" style={{ padding: "0" }} />
                </div>
                <h4
                  className="productName"
                  style={{
                    color: "#4e732c",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></h4>

                <div>
                  <p
                    dir="rtl"
                    lang="ar"
                    style={{ color: "white", float: "left" }}
                  >
                    طبقت طبقا للمواصفات والمعايير العالمية وانواعه كالاتي: -
                    <br />
                    1. زيتون أخضر محشي جزر
                    <br />
                    2. زيتون أخضر محشي فلفل
                    <br />
                    3. زيتون أخضر محشي فلفل هالبينو أخضر
                    <br />
                    4. زيتون أخضر محشي ثوم
                    <br />
                    5. زيتون أخضرمحشي لوز
                    <br />
                    6. زيتون أخضر محشي ليمون
                    <br />
                    7. زيتون أخضر محشي خيار
                  </p>
                  <div>
                    {" "}
                    <table class="  table-bordered ">
                      <thead>
                        <tr>
                          <th>وصف السلعة</th>
                          <th>الحجم (المعايير اليونانية) </th>
                          <th>قطع زيتون / كيلو جرام (معيار اسباني)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <th rowSpan="10">زيتون أخضر محشي</th>
                          <td> أطلس </td>
                          <td>70-90</td>
                        </tr>
                        <tr>
                          <td> سوبر ماموث</td>
                          <td> 91-100</td>
                        </tr>
                        <tr>
                          <td> ماموث</td>
                          <td>101-110</td>
                        </tr>
                        <tr>
                          <td> سوبر كلوسال</td>
                          <td>111-120</td>
                        </tr>
                        <tr>
                          <td>كلوسال</td>
                          <td>121-141</td>
                        </tr>
                        <tr>
                          <td> جانتس</td>
                          <td> 141-160</td>
                        </tr>
                        <tr>
                          <td> اكسترا جامبو</td>
                          <td>161-180</td>
                        </tr>
                        <tr>
                          <td> جامبو</td>
                          <td> 181-200</td>
                        </tr>
                        <tr>
                          <td> اكسترا لارج</td>
                          <td> 201-230</td>
                        </tr>
                        <tr>
                          <td>لارج</td>
                          <td> 231-260</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    className="btn get bgDark"
                    style={{ marginBottom: "5px" }}
                    onClick={showForm}
                  >
                    احصل علي عرض الاسعار
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <form onSubmit={sendQuote}>
                    <div className="showForm d-none ">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Enter Your Name"
                        style={{ marginBottom: "5px" }}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <input
                        type="email"
                        className="form-control"
                        // id="exampleFormControlInput2"
                        id="email"
                        placeholder="Enter Your Email"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <div
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <button
                          className="btn get"
                          style={{ marginTop: "5px" }}
                          type="submit"
                        >
                          {loading ? (
                            <i className="fa-solid fa-spinner fa-spin"></i>
                          ) : (
                            "ارسال"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* <img src={image1} alt="image not found" className='lightBox'/> */}

          <i
            style={{
              color: "black",
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "10px",
            }}
            id="close"
            className="fa-solid fa-xmark"
            onClick={closeSlide}
          ></i>
        </div>
      </div>
    </>
  );
}
